import { StatisticsOrder, StatisticsOrderQuery } from '@dreryk/egabinet-statistics-frontend-api';

import { useCqrsFind, UseCqrsQueryResult } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';

export const useFindStatisticsOrder: (statisticsId: number) => UseCqrsQueryResult<StatisticsOrder | null> = (
   statisticsId
) => {
   return useCqrsFind<StatisticsOrder>(
      () => {
         const query = new StatisticsOrderQuery();
         query.id = Slot.of(statisticsId);
         return query;
      },
      { cacheTime: 'long' }
   );
};
